import React from 'react';
import Text from './base';

const H6 = props => <Text defaultTag="h6" variant="h6" {...props} />;

export default H6;
